import React, {useState}from "react";
import {Autocomplete, Button} from "@mui/material";
import TextField from "@mui/material/TextField";
import Tooltip from "../Tooltip";
import DownloadIcon from "@mui/icons-material/Download";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import FunctionsIcon from "@mui/icons-material/Functions";
import {View} from "./classes/view/View";


function downloadCSV(view) {
    let csv = [];
    let cells = view.getActiveColumnDefs().map(col => col.displayName);
    let asString = JSON.stringify(cells);
    let asCsv = asString.substr(1, asString.length - 2); // Remove the surrounding brackets
    csv.push(asCsv);
    for (let row of view.getViewableRows()) {
        cells = Array.from(row.cells).map(cell => cell.getDOMText());
        asString = JSON.stringify(cells);
        asCsv = asString.substr(1, asString.length - 2); // Remove the surrounding brackets
        csv.push(asCsv);
    }
    const blob = new Blob([csv.join("\n")], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "table_export.csv";
    a.click();
    URL.revokeObjectURL(url);
}


export const TableControls = ({
    compact,
    makeCompact,
    page,
    pageSize ,
    setPage,
    setPageSize ,
    setShowViewMenu,
    showViewMenu,
    suffix,
    totalRows,
    view,
    additionalActions,
}) => {

    const [preparing, setPreparing] = useState(false);

    const getPageOptions = () => {
        const options = [];
        for (let i = 1; i <= Math.ceil(totalRows / pageSize); i++) {
            options.push({ label: (i + 1).toString(), value: i });
        }
        return options;
    }

    return <div className={"canold-table-controls"} role={`canold-table-controls-${suffix}`}>
        <div style={{display: "flex", alignItems: "center"}}>
            <Button
                onClick={() => setPage(prev => Math.max(prev - 1, 0))}
                disabled={page === 0}
            >Previous</Button>
            <div style={{display: "flex", alignItems: "center"}}>
                <p>Page&nbsp;</p>
                <Autocomplete
                    className={"canold-table-footer-page-size-dropdown"}
                    filterSelectedOptions
                    id={"jump-to-page"}
                    name={"jump-to-page"}
                    options={getPageOptions()}
                    disablePortal={false}
                    disabled={(page + 1) * pageSize >= totalRows}
                    isOptionEqualToValue={(option, value) => {
                        return option.value === value.value;
                    }}
                    onChange={(evt, data) => {
                        if (!data || !data.value) return;
                        setPage(data.value);
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            label={(page + 1).toString()}
                            placeholder={(page + 1).toString()}
                        />
                    )}
                />
                <p>&nbsp;of {parseInt(Math.ceil(totalRows / pageSize)) || 1}</p>
            </div>
            <Button
                onClick={() => setPage(prev => prev + 1)}
                disabled={(page + 1) * pageSize >= totalRows}
            >Next</Button>
        </div>
        <div style={{display: "flex", alignItems: "center"}}>
            <Autocomplete
                className={"canold-table-footer-page-size-dropdown"}
                filterSelectedOptions
                id={"pageSize-" + suffix}
                name={"pageSize-" + suffix}
                key={"pageSize-" + suffix}
                options={[
                    { label: "10", value: 10 },
                    { label: "25", value: 25 },
                    { label: "50", value: 50 },
                    { label: "100", value: 100 }
                ]}
                disablePortal={false}
                isOptionEqualToValue={(option, value) => {
                    return option.value === value.value;
                }}
                onChange={(evt, data) => {
                    if (!data || !data.value) return;
                    setPageSize(data.value);
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={pageSize.toString()}
                        placeholder={pageSize.toString()}
                    />
                )}
            /><p>&nbsp;rows per page</p>
        </div>
        <Button
            style={{float: "right", marginBottom: "10px", marginTop: "10px"}}
            className="canold-table-download"
            role={`canold-table-download-button-${suffix}`}
            variant="contained"
            key={"download-csv-" + suffix}
            onClick={() => {
                setPreparing(true);
                setTimeout(() => {
                    try {
                        downloadCSV(view)
                    } catch (e) {
                        console.error("Error downloading CSV:", e);
                    }
                    setPreparing(false);
                }, 1);
            }}>
            <DownloadIcon/> &nbsp; Download CSV {preparing ? "Preparing..." : ""}
        </Button>
        <Button
            style={{float: "right", marginBottom: "10px", marginTop: "10px"}}
            className="canold-table-compact-button"
            role={`canold-table-compact-button-${suffix}`}
            variant="contained"
            key={"compact-button-" + suffix}
            onClick={() => makeCompact()}>
            {compact ? <UnfoldMoreIcon/> : <UnfoldLessIcon/>} &nbsp; {compact ? "Expand View" : "Compact View"}
        </Button>
        <Button
            role={`canold-table-view-menu-button-${suffix}`}
            className={"canold-table-view-menu-icon"}
            onClick={() => setShowViewMenu(!showViewMenu)}
            variant="contained"
        >
            <FunctionsIcon/> &nbsp; Report Builder
        </Button>
        {preparing && <div className="canold-table-preparing"><p>Preparing download...</p></div>}
        {additionalActions}
    </div>
};

export default TableControls;
